import { useContext } from "react";
import { useLatestQuery } from "../../../WSUtils/useLatestQuery";
import { UserInfoContext } from "../../../WSUtils/UserInfoContext";
import { sentryAssertData } from "../../../WSUtils/wsSentry";
import { getQuestionFormToken } from "./getQuestionFormToken";

export const useQuestionFormAnswers = (questionFormLogId: number) => {
  const userInfo = useContext(UserInfoContext);
  const questionFormAPI = userInfo.fullAPI.questionFormAPI;
  const token = getQuestionFormToken();

  const { data: answers } = useLatestQuery(
    ["questionFormAPI.getAnswers", questionFormLogId],
    () =>
      questionFormAPI.getAnswers({
        questionFormLogId: questionFormLogId,
        userInfo: userInfo,
      }),
    { enabled: !!questionFormLogId && !token } // only fetch this when previous query is done
  );

  const { data: anonymousAnswers } = useLatestQuery(
    ["questionFormAPI.getAnswers", questionFormLogId],
    () =>
      questionFormAPI.getAnswersAnonymous({
        token,
        userInfo,
      }),
    { enabled: !!questionFormLogId && !!token } // only fetch this when previous query is done
  );

  sentryAssertData([answers, anonymousAnswers], { userInfo });

  return {
    answers: anonymousAnswers ?? answers,
    isDone: answers || anonymousAnswers,
    responses: [answers, anonymousAnswers],
  };
};
